import PocketBase from 'pocketbase';

const PB_URL = 'https://api.dabi.ink';

export const pb = new PocketBase(PB_URL);

export const auth = {
  signUp: async (email, password, fullName) => {
    try {
      await pb.collection('users').create({
        email,
        password,
        passwordConfirm: password,
        name: fullName,
      });
      return await auth.signIn(email, password);
    } catch (e) {
      return { data: null, error: { message: e.message } };
    }
  },

  signIn: async (email, password) => {
    try {
      const result = await pb.collection('users').authWithPassword(email, password);
      return { data: result, error: null };
    } catch (e) {
      return { data: null, error: { message: e.message } };
    }
  },

  signOut: () => {
    pb.authStore.clear();
  },

  getUser: () => {
    return { data: { user: pb.authStore.isValid ? pb.authStore.model : null } };
  },

  onAuthChange: (callback) => {
    const unsub = pb.authStore.onChange((token, model) => {
      callback(null, model ? { user: model } : null);
    });
    return { data: { subscription: { unsubscribe: unsub } } };
  },
};

export const memoriesApi = {
  getAll: async ({ category, search, archived = false } = {}) => {
    try {
      let filter = `users = "${pb.authStore.model?.id}" && is_archived = ${archived}`;
      if (category && category !== 'all') filter += ` && category = "${category}"`;
      if (search) filter += ` && (content ~ "${search}" || title ~ "${search}")`;
      const data = await pb.collection('memories').getFullList({
        filter,
        sort: '-is_pinned,-created',
      });
      return { data, error: null };
    } catch (e) {
      return { data: [], error: e };
    }
  },

  create: async (record) => {
    try {
      const data = await pb.collection('memories').create({
        ...record,
        users: pb.authStore.model?.id,
      });
      return { data, error: null };
    } catch (e) {
      return { data: null, error: e };
    }
  },

  update: async (id, record) => {
    try {
      const data = await pb.collection('memories').update(id, record);
      return { data, error: null };
    } catch (e) {
      return { data: null, error: e };
    }
  },

  delete: async (id) => {
    try {
      await pb.collection('memories').delete(id);
      return { error: null };
    } catch (e) {
      return { error: e };
    }
  },

  togglePin: async (id, isPinned) => {
    return memoriesApi.update(id, { is_pinned: !isPinned });
  },

  subscribe: (userId, callback) => {
    pb.collection('memories').subscribe('*', callback);
    return { unsubscribe: () => pb.collection('memories').unsubscribe('*') };
  },
};

export const CATEGORIES = [
  { id: 'all',         label: 'All',          color: '#7F77DD' },
  { id: 'note',        label: 'Notes',        color: '#1D9E75' },
  { id: 'task',        label: 'Tasks',        color: '#378ADD' },
  { id: 'appointment', label: 'Appointments', color: '#D85A30' },
  { id: 'goal',        label: 'Goals',        color: '#BA7517' },
  { id: 'idea',        label: 'Ideas',        color: '#D4537E' },
  { id: 'person',      label: 'People',       color: '#639922' },
  { id: 'other',       label: 'Other',        color: '#888780' },
];
